import Big from "big.js";
import { lowerCase } from "lodash";

export const toHuman = (amountInCents: number | Big) => {
  amountInCents = isNaN(amountInCents) ? 0 : Number(amountInCents);
  return (amountInCents / 100).toFixed(2);
};

export const toDollars = (amountInDollars: number | Big) => {
  if (amountInDollars == 0 || isNaN(amountInDollars)) return "$0.00";
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(amountInDollars);
};

export const toHumanDollars = (amountInCents: number) => {
  if (amountInCents == 0 || isNaN(amountInCents)) return "$0.00";
  const amount = (amountInCents / 100).toFixed(2);
  return toDollars(amount);
};

export const toWebUIDollars = (amount: number) => {
  return amount >= 0 ? toDollars(amount) : `(${toDollars(amount * -1)})`;
}

export const fromHuman = (input: string | Big) => {
  return Number((Number(input) * 100).toFixed());
};

export const toAccountBalanceString = (amount: number) => {
  if (!amount || isNaN(amount) || amount >= 0 ){
    return toHumanDollars(amount);
  } else {
    //Negative balance should be denoted with parentheses 
    return `(${toHumanDollars(Math.abs(amount))})`
  }
}

export const getHigherFeeCC = ({
  rent_cc_minimum,
  rent_cc_percent,
  initialAmount,
}: Record<string, number>) => {
  const proposedTotal = (rent_cc_percent / 100) * initialAmount;
  if (proposedTotal > rent_cc_minimum) {
    return { higherFee: "rent_cc_percent", rent_cc_percent };
  }
  return { higherFee: "rent_cc_minimum", rent_cc_minimum };
};

export const getHigherFeeBA = ({
  rent_ach_minimum,
  rent_ach_percent,
  initialAmount,
}: Record<string, number>) => {
  const proposedTotal = (rent_ach_percent / 100) * initialAmount;
  if (proposedTotal > rent_ach_minimum) {
    return { higherFee: "rent_ach_percent", rent_ach_percent };
  }
  return { higherFee: "rent_ach_minimum", rent_ach_minimum };
};

export const isBalanceError = (balance: string) => {
  return lowerCase(balance) === "temporarily unavailable";
};
